@if (loading$ | async) {
  <div class="spinner-container">
    <div class="loader"></div>
  </div>
}
